import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { formatAsDistance, formatAsEmission } from 'cpfr-common';
import CmsBackend from './cmsBackend';

i18next
    .use(LanguageDetector)
    .use(CmsBackend)
    .use(initReactI18next)
    .init({
        fallbackLng: 'fr',
        load: 'languageOnly',
        preload: ['fr'],
        ns: [
            'bundled-products',
            'contact-details-check',
            'contract-end-options',
            'contract-parties',
            'contracts',
            'dashboard',
            'early-settlement',
            'financial-details',
            'financial-details-osp',
            'greeting',
            'my-profile',
            'navigation',
            'notification-center',
            'registration',
            'request',
            'translation',
            'vehicle-details',
            'landing-page',
            'my-documents',
            'request-history',
            'my-profile-cms',
            'early-settlement-cms',
            'contract-end-options-cms',
            'faq-cms',
            'errors-cms',
            'incydent-notification-cms',
            'time-out-notification',
            'loader',
        ],
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
            format(value, format) {
                if (format === 'distance') {
                    return formatAsDistance(value);
                }
                if (format === 'emission') {
                    return formatAsEmission(value);
                }
                return value;
            },
        },
        backend: {
            cmsNamespaces: [
                'my-profile-cms',
                'early-settlement-cms',
                'contract-end-options-cms',
                'faq-cms',
                'errors-cms',
                'incydent-notification-cms',
            ],
        },
        whitelist: ['fr'],
        lng: 'fr',
    });

export default i18next;
